exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".iframeDiv {\n  width: 100%;\n  padding: 0em 1em 0em 1em;\n  margin: 0; }\n\n.iframeDiv iframe {\n  border: none;\n  width: 100%; }\n", ""]);

